module.exports = __webpack_public_path__ + "static/media/quote-start.b81d02d2.svg";